import * as types from "../../_constants/types";

export default (state = {}, action) => {
    switch (action.type) {
        case types.ORDER_LOAD:
            return Object.assign({}, action.results);

        case types.RESET:
        case types.ORDER_RESET:
            return {};

        default:
            return state;
    }
};
